export const FORM_TYPE = {
  CONTACT_US: 'FLContactUs',
  NEWSLETTER: 'FLNewsletter',
  CONTACT_COMPANY: 'FlContactCompany',
  BECOME_AN_AUTHOR: 'FLBecomeAContributor',
  SUGGEST_A_TERM: 'SuggestATerm'
}
